import React from 'react';
import { HeroCarousel } from '../../components/sections/Hero';
import AboutSection from '../../components/sections/AboutSection';
import TrackingSection from '../../components/sections/TrackingSection';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Home page component
 */
const Home = () => {
  const { t } = useLanguage();

  return (
    <main className="home" role="main">
      {/* Hero Section */}
      <section aria-label="Ana görsel slider" className="-mt-[88px]">
        <HeroCarousel />
      </section>

      {/* About Section */}
      <AboutSection />

      {/* Tracking Section */}
      <TrackingSection />
    </main>
  );
};

export default Home;
